import { ExcelButton } from "@/controls/buttons/Excel-button";
import { ErrorModal, getMomentTz, useShiftNavigator } from "@dexteel/mesf-core";
import { Grid, Paper, Typography } from "@material-ui/core";
import { ProcessCellForExportParams } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useRef, useState } from "react";
import { getFailedStartup } from "../repositories/ProductionRepository";
import { FailedStartupTable } from "./components/FailedStartupTable";
import { Filters } from "./components/Filters";

const moment = getMomentTz();

interface FiltersType {
	fromDate: Date;
	toDate: Date;
	shift: string | null;
	crew: string | null;
}

export const FailedStartupPage = () => {
	const gridRef = useRef<AgGridReact>(null);
	const { shiftInfo } = useShiftNavigator();
	const shiftDate = moment(shiftInfo?.CurrentStart).format("MM-DD-YYYY");

	const [heats, setHeats] = useState<any[]>([]);
	const [filters, setFilters] = useState<FiltersType>({
		fromDate: moment.utc().subtract(1, "month").toDate(),
		toDate: moment.utc().toDate(),
		shift: "All",
		crew: "All",
	});
	const [error, setError] = useState("");

	const getFailedStartupHeats = async () => {
		const resp = await getFailedStartup({
			...filters,
			shift: filters.shift === "All" ? null : filters.shift,
			crew: filters.crew === "All" ? null : filters.crew,
		});
		if (resp.ok) {
			setHeats(resp.data.tables[0].rows);
		} else {
			setError(resp.message);
		}
	};

	useEffect(() => {
		getFailedStartupHeats();
	}, [filters]);

	const handleExportToExcel = () => {
		if (gridRef.current && gridRef.current.api) {
			const params = {
				skipHeader: false,
				skipFooters: true,
				skipGroups: true,
				fileName: `Failed-Startup-${shiftDate}.xlsx`,
				sheetName: "Failed Startup",
				processCellCallback: (params: ProcessCellForExportParams) => {
					const val = params.value;
					return val ?? "";
				},
			};
			gridRef.current.api.exportDataAsExcel(params);
		} else {
			setError("Unable to export data. Please try again.");
		}
	};

	return (
		<>
			<Paper
				elevation={0}
				style={{
					width: "100%",
					padding: "20px 20px",
					height: "93vh",
					backgroundColor: "#f2f4f7",
				}}
			>
				<Grid container justifyContent="center" alignItems="center">
					<Grid item md={12} xs={12} container spacing={2}>
						<Grid
							container
							direction="row"
							justifyContent="space-between"
							alignItems="center"
						>
							<Typography variant="h5" style={{ fontWeight: 600 }}>
								Failed Startup
							</Typography>
						</Grid>
					</Grid>
					<Grid item md={"auto"} xs={"auto"}>
						<Grid
							item
							container
							justifyContent="flex-start"
							alignItems="center"
						>
							<Filters
								onFilterChange={(fromDate, toDate, shift, crew) =>
									setFilters({ fromDate, toDate, shift, crew })
								}
								initialFromDate={filters.fromDate}
								initialToDate={filters.toDate}
								filterShift={filters.shift}
								onFilterShiftChange={(shift) =>
									setFilters((prev) => ({ ...prev, shift }))
								}
								filterCrew={filters.crew}
								onFilterCrewChange={(crew) =>
									setFilters((prev) => ({ ...prev, crew }))
								}
							/>
						</Grid>
					</Grid>
					<Grid item xs={"auto"} style={{ marginLeft: "auto" }}>
						<ExcelButton onClick={handleExportToExcel} />
					</Grid>
					<Grid item xs={12} container spacing={2}>
						<FailedStartupTable
							rows={heats}
							isLoading={false}
							gridRef={gridRef}
						/>
					</Grid>
				</Grid>
			</Paper>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
